import React from "react";
import "../../App.css";
import spain1 from "./IMGsmall/spain1.jpg";
import spain2 from "./IMGsmall/spain2.jpg";
import spain3 from "./IMGsmall/spain3.jpg";
import Footer from "./Footer";

export default function Spain() {
  return (
    <>
      <div class="spain">
        <h1>VALENCIA</h1>
        <div class="IMGsmoll">
          <img class="valencia" alt="artsNsciences" src={spain1} />
          <img class="valencia" alt="oceanographic1" src={spain2} />
          <img class="valencia" alt="oceanographic2" src={spain3} />
        </div>
      </div>
      <Footer />
    </>
  );
}
